(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ep-mega-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ep-mega-menu')) {
    class EPMegaMenu extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.navigation = this.querySelector('[data-ep-navigation]');
        this.desktop = this.querySelector('[data-ep-menu-desktop]');
        this.drawer = this.querySelector('.ep-menu-drawer');
        this.drawerBody = this.querySelector('[data-ep-menu-drawer-body]');
        this.closeButton = this.querySelector('[data-ep-menu-close]');
        if (!this.navigation || !this.drawer) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.compact = matchMedia('(max-width: 990px), (hover: none), (pointer: coarse)');
        this.items = [...this.querySelectorAll('[data-ep-category]')];
        this.syncTriggers();
        this.compact.addEventListener('change', () => this.changeMode(), { signal });
        document.addEventListener('focusin', (event) => {
          if (event.target !== document.body) this.navigationFocused = this.navigation.contains(event.target);
        }, { signal });
        document.addEventListener('shopify:section:load', () => this.syncTriggers(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const item = this.items.find((entry) => entry.dataset.blockId === event.detail?.blockId);
          if (!item) return;
          if (this.compact.matches) this.openDrawer(this.triggers[0]);
          this.setCategory(item, true);
        }, { signal });
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ep-menu-toggle]');
          if (trigger && trigger.getAttribute('aria-controls') === this.drawer.id) {
            this.openDrawer(trigger);
          } else if (!this.contains(event.target)) {
            this.closeCategories();
          }
        }, { signal });
        this.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-ep-category-toggle]');
          if (toggle && this.contains(toggle)) {
            const item = toggle.closest('[data-ep-category]');
            const open = toggle.getAttribute('aria-expanded') !== 'true' || item.hasAttribute('data-hover-open');
            item.removeAttribute('data-hover-open');
            this.setCategory(item, open);
          }
          if (this.drawer.open && event.target.closest('a[href]')) this.closeDrawer(false);
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && this.drawer.open) {
            const controls = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')].filter((entry) => entry.getClientRects().length > 0);
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last?.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first?.focus();
            }
            return;
          }
          if (event.key !== 'Escape' || this.drawer.open) return;
          const item = this.items.find((entry) => entry.hasAttribute('data-open'));
          if (!item) return;
          event.preventDefault();
          this.setCategory(item, false);
          item.querySelector('[data-ep-category-toggle]')?.focus();
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (this.compact.matches) return;
          const item = this.items.find((entry) => entry.hasAttribute('data-open'));
          if (item && !item.contains(event.relatedTarget)) this.closeCategories();
        }, { signal });
        this.items.forEach((item) => {
          item.addEventListener('pointerenter', (event) => {
            if (!this.compact.matches && event.pointerType === 'mouse' && !item.hasAttribute('data-open')) {
              this.setCategory(item, true);
              if (item.hasAttribute('data-open')) item.setAttribute('data-hover-open', '');
            }
          }, { signal });
          item.addEventListener('pointerleave', (event) => {
            if (!this.compact.matches && event.pointerType === 'mouse' && !item.contains(document.activeElement)) this.setCategory(item, false);
          }, { signal });
        });
        this.closeButton.addEventListener('click', () => this.closeDrawer(), { signal });
        this.drawer.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeDrawer();
        }, { signal });
        this.drawer.addEventListener('close', () => this.finishDrawerClose(), { signal });
        this.drawer.addEventListener('pointerdown', (event) => {
          if (event.target !== this.drawer) return;
          const bounds = this.drawer.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            event.preventDefault();
            this.closeDrawer();
          }
        }, { signal });
        window.addEventListener('resize', () => this.updateAvailableHeight(), { signal });
      }

      disconnectedCallback() {
        this.closeDrawer(false);
        this.closeCategories();
        this.controller?.abort();
        this.controller = null;
        this.triggers?.forEach((trigger) => {
          if (trigger.getAttribute('aria-controls') !== this.drawer?.id) return;
          trigger.hidden = true;
          trigger.removeAttribute('aria-controls');
          delete trigger.dataset.epMenuOwner;
        });
      }

      syncTriggers() {
        const scope = this.closest('#header-group') || document;
        this.triggers = [...scope.querySelectorAll('[data-ep-menu-toggle]')].filter((trigger) => !trigger.dataset.epMenuOwner || trigger.dataset.epMenuOwner === this.id);
        this.triggers.forEach((trigger) => {
          trigger.dataset.epMenuOwner = this.id;
          trigger.setAttribute('aria-controls', this.drawer.id);
          trigger.setAttribute('aria-expanded', String(this.drawer.open));
          trigger.hidden = !this.compact.matches;
        });
      }

      changeMode() {
        const drawerWasOpen = this.drawer.open;
        const navigationHadFocus = this.navigation.contains(document.activeElement) || this.navigationFocused;
        this.closeDrawer(false);
        this.closeCategories();
        this.syncTriggers();
        if (drawerWasOpen && !this.compact.matches) this.navigation.querySelector('a[href], button')?.focus({ preventScroll: true });
        if (navigationHadFocus && this.compact.matches) this.triggers[0]?.focus({ preventScroll: true });
      }

      setCategory(item, open) {
        const toggle = item?.querySelector('[data-ep-category-toggle]');
        const panel = item?.querySelector('.ep-mega-dropdown');
        if (!toggle || !panel) {
          if (!this.compact.matches) this.closeCategories();
          return;
        }
        if (open) this.closeCategories(item);
        item.toggleAttribute('data-open', open);
        if (!open) item.removeAttribute('data-hover-open');
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        this.updateAvailableHeight();
        this.updateOverlay();
      }

      closeCategories(except) {
        this.items?.forEach((item) => {
          if (item === except) return;
          item.removeAttribute('data-open');
          item.removeAttribute('data-hover-open');
          item.querySelector('[data-ep-category-toggle]')?.setAttribute('aria-expanded', 'false');
          const panel = item.querySelector('.ep-mega-dropdown');
          if (panel) panel.hidden = true;
        });
        this.updateOverlay();
      }

      updateOverlay() {
        const openDesktopMenu = document.querySelector('ep-mega-menu .ep-menu-desktop [data-ep-category][data-open]');
        document.body.classList.toggle('menu-open', Boolean(openDesktopMenu));
      }

      updateAvailableHeight() {
        if (this.compact?.matches || !this.navigation) return;
        this.style.setProperty('--ep-menu-available-height', `${Math.max(100, window.innerHeight - this.navigation.getBoundingClientRect().bottom - 16)}px`);
      }

      openDrawer(trigger) {
        if (!this.compact.matches || this.drawer.open) return;
        this.returnFocus = trigger;
        this.restoreFocus = true;
        this.closeCategories();
        this.drawerBody.append(this.navigation);
        this.previousOverflow = document.body.style.overflow;
        this.drawerActive = true;
        this.drawer.showModal();
        document.body.style.overflow = 'hidden';
        this.triggers.forEach((entry) => entry.setAttribute('aria-expanded', 'true'));
        this.closeButton.focus({ preventScroll: true });
      }

      closeDrawer(restoreFocus = true) {
        if (!this.drawerActive) return;
        this.restoreFocus = restoreFocus;
        if (this.drawer.open) this.drawer.close();
        this.finishDrawerClose();
      }

      finishDrawerClose() {
        if (!this.drawerActive) return;
        this.drawerActive = false;
        this.desktop.append(this.navigation);
        this.closeCategories();
        document.body.style.overflow = this.previousOverflow;
        this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        const trigger = this.returnFocus?.isConnected ? this.returnFocus : this.triggers.find((entry) => entry.isConnected && !entry.hidden);
        if (this.restoreFocus && trigger && !trigger.hidden) trigger.focus({ preventScroll: true });
      }
    }
    customElements.define('ep-mega-menu', EPMegaMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ep-footer-navigation')) {
  customElements.define('ep-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.items = new Map();
      this.desktop = matchMedia('(min-width: 992px)');
      this.desktop.addEventListener('change', () => this.sync(true), { signal: this.events.signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (this.desktop.matches || !(event.target instanceof Element) || !this.contains(event.target)) return;
        const item = event.target.closest('accordion-custom.menu--accordion') || event.target.querySelector('accordion-custom.menu--accordion');
        if (item) item.querySelector('details').open = true;
      }, { signal: this.events.signal });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true });
      this.sync();
    }
    sync(reset = false) {
      const columns = Array.from(this.children).filter(node => !['SCRIPT','STYLE','TEMPLATE'].includes(node.tagName) && !node.hidden && getComputedStyle(node).display !== 'none').length;
      this.dataset.columns = columns;
      this.parentElement.style.setProperty('--ep-footer-columns', Math.max(1,columns));
      for (const [item,state] of this.items) {
        if (!this.contains(item)) { this.restore(item,state); this.items.delete(item); }
      }
      for (const item of this.querySelectorAll('accordion-custom.menu--accordion')) {
        let state = this.items.get(item);
        const isNew = !state;
        if (isNew) {
          const details = item.querySelector('details');
          const summary = details?.querySelector('summary');
          if (!summary) continue;
          state = { details, summary, events: new AbortController(), attributes: new Map(), tab: summary.getAttribute('tabindex'), aria: summary.getAttribute('aria-disabled') };
          for (const name of ['data-disable-on-mobile','data-disable-on-desktop','open-by-default-on-mobile','open-by-default-on-desktop']) state.attributes.set(name,item.getAttribute(name));
          details.addEventListener('toggle', () => {
            if (this.desktop.matches) return;
            item.toggleAttribute('open-by-default-on-mobile',details.open);
            item.toggleAttribute('open-by-default-on-desktop',details.open);
          }, { signal: state.events.signal });
          this.items.set(item,state);
        }
        if (!isNew && !reset) continue;
        const wide = this.desktop.matches;
        item.dataset.disableOnMobile = String(wide);
        item.dataset.disableOnDesktop = String(wide);
        item.toggleAttribute('open-by-default-on-mobile',wide);
        item.toggleAttribute('open-by-default-on-desktop',wide);
        state.details.open = wide;
        if (wide) { state.summary.setAttribute('tabindex','-1'); state.summary.setAttribute('aria-disabled','true'); }
        else { state.summary.removeAttribute('tabindex'); state.summary.removeAttribute('aria-disabled'); }
      }
    }
    restore(item,state) {
      state.events.abort();
      for (const [name,value] of state.attributes) { if (value === null) item.removeAttribute(name); else item.setAttribute(name,value); }
      for (const [name,value] of [['tabindex',state.tab],['aria-disabled',state.aria]]) { if (value === null) state.summary.removeAttribute(name); else state.summary.setAttribute(name,value); }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      for (const [item,state] of this.items || []) this.restore(item,state);
      this.items?.clear();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
